import { type IGoogleAnalyticsTrackingType, type IMediaCard } from '@pcln/contentful-components'
import { Badge, MediaCard } from '@pcln/horizon'
import { useEffect, useState } from 'react'

import analytics from '@/shared-utils/analytics'
import type { ModalContent } from '@/types'

import MoreInfoModal from '../Modal/MoreInfoModal'
import { getCallToActionProps, fireSelectPromotion } from './utils'

export default function MediaCardComponentHorizon({ content }: Readonly<{ content: IMediaCard }>) {
  const {
    adText,
    analyticsTracking,
    badgeText,
    callToAction,
    coupon,
    eyebrow,
    heading,
    list,
    media,
    primaryCallToAction,
    promoCode,
    subheading,
  } = content

  // TODO: Remove coupon once coupon is deprecated
  const promoCodeCoupon = promoCode ?? coupon

  const promoCodeProps =
    promoCodeCoupon?.couponCodeId && promoCodeCoupon.couponCodeText
      ? { code: promoCodeCoupon.couponCodeId, discount: promoCodeCoupon.couponCodeText }
      : undefined
  const [isOpen, setIsOpen] = useState(false)
  const [currentModalProps, setCurrentModalProps] = useState<ModalContent>()

  const handleOpen = (modalProps: ModalContent, gaTracking?: IGoogleAnalyticsTrackingType) => {
    fireSelectPromotion(gaTracking)
    if (modalProps.body || modalProps.heading || modalProps.paragraph) {
      setCurrentModalProps(modalProps)
      setIsOpen(true)
    }
  }

  const handleClose = () => {
    setCurrentModalProps(undefined)
    setIsOpen(false)
  }

  const { callToActionSlot, ...callToActionProps } = getCallToActionProps({
    callToAction: callToAction ?? primaryCallToAction,
    onModalOpen: handleOpen,
  })

  useEffect(() => {
    const ga4Parameters = analyticsTracking?.parameters
    if (ga4Parameters) {
      analytics.fireGA4Event({
        event: 'view_promotion',
        attributes: {
          ...ga4Parameters?.attributes,
        },
      })
    }
  }, [analyticsTracking])

  const mediaUrl = media?.file?.url

  return (
    <>
      <MoreInfoModal {...currentModalProps} isFullHeight={false} isOpen={isOpen} handleClose={handleClose} />
      <MediaCard
        {...callToActionProps}
        callToActionSlot={callToActionSlot}
        adSlot={adText}
        headingSlot={heading}
        bodySlot={subheading}
        contentfulRichTextSlot={list}
        eyebrowSlot={eyebrow}
        mediaSlot={mediaUrl ? { contentfulUrl: mediaUrl, alt: media?.title ?? heading ?? '' } : undefined}
        badgeSlot={
          badgeText && (
            <Badge palette='neutral' size='sm'>
              {badgeText}
            </Badge>
          )
        }
        showPromoCode={!!promoCodeProps}
        promoCodeProps={promoCodeProps}
        className='w-full'
      />
    </>
  )
}
